import { useUserRole } from 'api';
import { Link, type LinkProps } from 'ui';

export const AdminLink = ({ children, ...rest }: LinkProps) => {
  const role = useUserRole();

  if (role !== 'admin') {
    return null;
  }
  return <Link {...rest}>{children}</Link>;
};
